import { FC } from 'react'

import useProductPage from 'src/hooks/useProductPage'
import useToggleFavoriteDashboard from 'src/hooks/useToggleFavoriteDashboard'
import useSelectedDashboardStore from 'src/stores/useSelectedDashboardStore'
import DropdownMenuItem from '../../../atoms/DropdownMenuItem'
import PinIcon from '../../../atoms/Icons/PinIcon'
import UnPinIcon from '../../../atoms/Icons/UnPinIcon'
import { usePopupButtonContext } from '../../../atoms/PopupButton/PopupButtonProvider'

const SetAsDefaultDashboardMenuItem: FC = () => {
  const { toggle } = usePopupButtonContext()
  const { code: subProductCode, program } = useProductPage()
  const { selectedDashboard } = useSelectedDashboardStore()

  const { handleSetDefaultDashboard, loading, isFavorite } = useToggleFavoriteDashboard({
    subProductCode,
    program,
    dashboard: selectedDashboard,
  })

  const handleClick = () => {
    handleSetDefaultDashboard()
    toggle(false)
  }

  return (
    <DropdownMenuItem
      icon={
        isFavorite ? (
          <UnPinIcon width={undefined} height={undefined} className="text-rolling-stone size-4" />
        ) : (
          <PinIcon width={undefined} height={undefined} className="text-rolling-stone size-4" />
        )
      }
      label={isFavorite ? 'Unpin' : 'Set as default'}
      data-testid="header-dashboard-menu-set-default"
      onClick={handleClick}
      disabled={loading}
    />
  )
}

export default SetAsDefaultDashboardMenuItem
